;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('slider', slider)

  function slider () {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: '/core/directives/slider/slider-directive.html?$$REVISION$$',
      controller: 'SliderController'
    }
  }
})()
